<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'

const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

function getStartOfWeek(date) {
  const result = new Date(date)
  const day = result.getDay()
  const diff = (day + 6) % 7

  result.setDate(result.getDate() - diff)
  result.setHours(0, 0, 0, 0)

  return result
}

function addDays(date, days) {
  const result = new Date(date)
  result.setDate(result.getDate() + days)

  return result
}

function toDateKey(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

function fromDateKey(dateKey) {
  const [year, month, day] = dateKey.split('-').map(Number)

  return new Date(year, month - 1, day)
}

function formatDateShort(date) {
  return `${date.getDate()} ${MONTH_NAMES[date.getMonth()]}`
}

function buildMockWorkOrders(weekStart) {
  return [
    {
      id: 101,
      code: 'WO-240801',
      title: 'Preventive maintenance GPS unit',
      customer: 'PT Sumber Makmur',
      location: 'Cakung, Jakarta Timur',
      priority: 'High',
      status: 'Planned',
      technicianId: 1,
      date: toDateKey(addDays(weekStart, 0)),
      startHour: 8,
      durationHours: 2,
      startDate: toDateKey(addDays(weekStart, 0)),
      endDate: toDateKey(addDays(weekStart, 1)),
      startHourLimit: 8,
      endHourLimit: 17,
    },
    {
      id: 102,
      code: 'WO-240802',
      title: 'Install dashboard camera',
      customer: 'CV Logistik Prima',
      location: 'Bekasi Barat',
      priority: 'Medium',
      status: 'Planned',
      technicianId: 2,
      date: toDateKey(addDays(weekStart, 1)),
      startHour: 10,
      durationHours: 3,
      startDate: toDateKey(addDays(weekStart, 1)),
      endDate: toDateKey(addDays(weekStart, 2)),
      startHourLimit: 9,
      endHourLimit: 18,
    },
    {
      id: 103,
      code: 'WO-240803',
      title: 'Troubleshoot tracker offline',
      customer: 'PT Nusantara Fleet',
      location: 'Tangerang Selatan',
      priority: 'Urgent',
      status: 'Open',
      technicianId: null,
      date: null,
      startHour: null,
      durationHours: 1,
      startDate: toDateKey(addDays(weekStart, 0)),
      endDate: toDateKey(addDays(weekStart, 2)),
      startHourLimit: 8,
      endHourLimit: 15,
    },
    {
      id: 104,
      code: 'WO-240804',
      title: 'Replace damaged harness cable',
      customer: 'PT Armada Jaya',
      location: 'Depok',
      priority: 'High',
      status: 'Planned',
      technicianId: 4,
      date: toDateKey(addDays(weekStart, 3)),
      startHour: 13,
      durationHours: 2,
      startDate: toDateKey(addDays(weekStart, 3)),
      endDate: toDateKey(addDays(weekStart, 4)),
      startHourLimit: 12,
      endHourLimit: 20,
    },
    {
      id: 105,
      code: 'WO-240805',
      title: 'Calibration fuel sensor',
      customer: 'PT Borneo Energi',
      location: 'Sunter, Jakarta Utara',
      priority: 'Medium',
      status: 'Ready',
      technicianId: null,
      date: null,
      startHour: null,
      durationHours: 2,
      startDate: toDateKey(addDays(weekStart, 2)),
      endDate: toDateKey(addDays(weekStart, 5)),
      startHourLimit: 7,
      endHourLimit: 16,
    },
    {
      id: 106,
      code: 'WO-240806',
      title: 'New vehicle device activation',
      customer: 'PT Trans Indo',
      location: 'Karawang',
      priority: 'Low',
      status: 'Open',
      technicianId: null,
      date: null,
      startHour: null,
      durationHours: 1,
      startDate: toDateKey(addDays(weekStart, 4)),
      endDate: toDateKey(addDays(weekStart, 6)),
      startHourLimit: 18,
      endHourLimit: 23,
    },
    {
      id: 107,
      code: 'WO-240807',
      title: 'Night shift tracker replacement',
      customer: 'PT Garuda Distribusi',
      location: 'Marunda, Jakarta Utara',
      priority: 'High',
      status: 'Planned',
      technicianId: 3,
      date: toDateKey(addDays(weekStart, 4)),
      startHour: 22,
      durationHours: 1,
      startDate: toDateKey(addDays(weekStart, 4)),
      endDate: toDateKey(addDays(weekStart, 6)),
      startHourLimit: 20,
      endHourLimit: 23,
    },
  ]
}

export default {
  page: {
    title: 'Calendar Schedule',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    const currentWeekStart = getStartOfWeek(new Date())

    return {
      calendarView: 'week',
      currentWeekStart,
      selectedDate: toDateKey(new Date()),
      draggedWorkOrderId: null,
      weeklyCapacityHours: 40,
      technicians: [
        { id: 1, name: 'Andi Pratama', role: 'Senior Technician', color: '#2f80ed' },
        { id: 2, name: 'Budi Santoso', role: 'Technician', color: '#27ae60' },
        { id: 3, name: 'Citra Lestari', role: 'Technician', color: '#f2994a' },
        { id: 4, name: 'Dewi Anggraini', role: 'Technician', color: '#9b51e0' },
      ],
      workOrders: buildMockWorkOrders(currentWeekStart),
    }
  },
  computed: {
    title() {
      return this.$t('planner.column.calendarSchedule')
    },
    description() {
      return this.$t('planner.subColumn.calendarSchedule')
    },
    hours() {
      return Array.from({ length: 24 }, (_, index) => index)
    },
    weekDays() {
      return Array.from({ length: 7 }, (_, index) => this.buildDay(addDays(this.currentWeekStart, index)))
    },
    visibleDays() {
      if (this.calendarView === 'day') return [this.buildDay(fromDateKey(this.selectedDate))]

      return this.weekDays
    },
    timelineSlots() {
      return this.visibleDays.flatMap((day) =>
        this.hours.map((hour) => ({
          dateKey: day.key,
          hour,
          id: `${day.key}-${hour}`,
        }))
      )
    },
    slotCount() {
      return this.timelineSlots.length
    },
    timelineGridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.slotCount}, minmax(0, 1fr))`,
      }
    },
    dayGroupStyle() {
      return {
        gridTemplateColumns: `repeat(${this.visibleDays.length}, minmax(0, 1fr))`,
      }
    },
    activeWeekEnd() {
      return addDays(this.currentWeekStart, 6)
    },
    activeWeekStartKey() {
      return toDateKey(this.currentWeekStart)
    },
    activeWeekEndKey() {
      return toDateKey(this.activeWeekEnd)
    },
    calendarRangeLabel() {
      if (this.calendarView === 'day') {
        const selectedDate = fromDateKey(this.selectedDate)
        return `${DAY_NAMES[selectedDate.getDay()]}, ${formatDateShort(selectedDate)} ${selectedDate.getFullYear()}`
      }

      return `${formatDateShort(this.currentWeekStart)} - ${formatDateShort(this.activeWeekEnd)} ${this.activeWeekEnd.getFullYear()}`
    },
    unscheduledWorkOrders() {
      return this.workOrders.filter(
        (item) => !item.date || item.startHour === null || item.startHour === undefined || !item.technicianId
      )
    },
  },
  methods: {
    buildDay(date) {
      return {
        key: toDateKey(date),
        label: DAY_NAMES[date.getDay()],
        dateLabel: formatDateShort(date),
      }
    },
    setCalendarView(view) {
      this.calendarView = view

      if (view === 'week') {
        this.currentWeekStart = getStartOfWeek(fromDateKey(this.selectedDate))
      }
    },
    goToPreviousPeriod() {
      if (this.calendarView === 'day') {
        const date = addDays(fromDateKey(this.selectedDate), -1)
        this.selectedDate = toDateKey(date)
        this.currentWeekStart = getStartOfWeek(date)
        return
      }

      this.currentWeekStart = addDays(this.currentWeekStart, -7)
    },
    goToCurrentPeriod() {
      const today = new Date()
      this.selectedDate = toDateKey(today)
      this.currentWeekStart = getStartOfWeek(today)
    },
    goToNextPeriod() {
      if (this.calendarView === 'day') {
        const date = addDays(fromDateKey(this.selectedDate), 1)
        this.selectedDate = toDateKey(date)
        this.currentWeekStart = getStartOfWeek(date)
        return
      }

      this.currentWeekStart = addDays(this.currentWeekStart, 7)
    },
    onDragStart(workOrder, event) {
      this.draggedWorkOrderId = workOrder.id

      if (event.dataTransfer) {
        event.dataTransfer.effectAllowed = 'move'
        event.dataTransfer.setData('text/plain', String(workOrder.id))
      }
    },
    onDragEnd() {
      this.draggedWorkOrderId = null
    },
    onDrop(technicianId, dateKey, hour, event) {
      const eventWorkOrderId = event && event.dataTransfer ? Number(event.dataTransfer.getData('text/plain')) : null
      const workOrderId = this.draggedWorkOrderId || eventWorkOrderId
      const workOrder = this.workOrders.find((item) => item.id === workOrderId)

      if (!workOrder || !this.isWorkOrderAllowedInSlot(workOrder, dateKey, hour)) return

      workOrder.technicianId = technicianId
      workOrder.date = dateKey
      workOrder.startHour = hour
      workOrder.status = 'Planned'
      this.draggedWorkOrderId = null
    },
    getWorkOrdersBySlot(technicianId, dateKey, hour) {
      return this.workOrders.filter(
        (item) => item.technicianId === technicianId && item.date === dateKey && item.startHour === hour
      )
    },
    getTechnicianWeekPlannedHours(technicianId) {
      return this.workOrders
        .filter(
          (item) =>
            item.technicianId === technicianId &&
            item.date >= this.activeWeekStartKey &&
            item.date <= this.activeWeekEndKey &&
            item.startHour !== null &&
            item.startHour !== undefined
        )
        .reduce((total, item) => total + item.durationHours, 0)
    },
    getTechnicianRemainingHours(technicianId) {
      return Math.max(this.weeklyCapacityHours - this.getTechnicianWeekPlannedHours(technicianId), 0)
    },
    getTechnicianUtilizationPercent(technicianId) {
      return Math.min((this.getTechnicianWeekPlannedHours(technicianId) / this.weeklyCapacityHours) * 100, 100)
    },
    isTechnicianOverCapacity(technicianId) {
      return this.getTechnicianWeekPlannedHours(technicianId) > this.weeklyCapacityHours
    },
    isWorkOrderAllowedInSlot(workOrder, dateKey, hour) {
      if (!workOrder.startDate || !workOrder.endDate) return true

      const endHour = hour + workOrder.durationHours
      const isDateAllowed = dateKey >= workOrder.startDate && dateKey <= workOrder.endDate
      const isHourAllowed = hour >= workOrder.startHourLimit && endHour <= workOrder.endHourLimit

      return isDateAllowed && isHourAllowed
    },
    getDraggedWorkOrder() {
      return this.workOrders.find((item) => item.id === this.draggedWorkOrderId) || null
    },
    isSlotAllowedForDraggedWorkOrder(dateKey, hour) {
      const workOrder = this.getDraggedWorkOrder()

      if (!workOrder) return true

      return this.isWorkOrderAllowedInSlot(workOrder, dateKey, hour)
    },
    getTechnician(technicianId) {
      return this.technicians.find((technician) => technician.id === technicianId) || null
    },
    getTechnicianName(technicianId) {
      const technician = this.getTechnician(technicianId)
      return technician ? technician.name : 'Unassigned'
    },
    getTechnicianColor(technicianId) {
      const technician = this.getTechnician(technicianId)
      return technician ? technician.color : '#6c757d'
    },
    getDateLabel(dateKey) {
      if (!dateKey) return 'Unscheduled'

      const date = fromDateKey(dateKey)
      return `${DAY_NAMES[date.getDay()]}, ${formatDateShort(date)}`
    },
    formatHour(hour) {
      if (hour === null || hour === undefined) return '--:--'
      return `${String(hour).padStart(2, '0')}:00`
    },
    formatWorkOrderTime(workOrder) {
      if (!workOrder.date || workOrder.startHour === null || workOrder.startHour === undefined) {
        return 'Not scheduled'
      }

      const endHour = Math.min(workOrder.startHour + workOrder.durationHours, 24)
      return `${this.getDateLabel(workOrder.date)} · ${this.formatHour(workOrder.startHour)}-${this.formatHour(endHour)}`
    },
    formatAllowedWindow(workOrder) {
      return `${this.getDateLabel(workOrder.startDate)} - ${this.getDateLabel(workOrder.endDate)} · ${this.formatHour(workOrder.startHourLimit)}-${this.formatHour(workOrder.endHourLimit)}`
    },
    getPriorityVariant(priority) {
      const variants = {
        Urgent: 'danger',
        High: 'warning',
        Medium: 'info',
        Low: 'secondary',
      }

      return variants[priority] || 'secondary'
    },
    getStatusVariant(status) {
      const variants = {
        Open: 'secondary',
        Ready: 'primary',
        Planned: 'success',
      }

      return variants[status] || 'secondary'
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="card mc-card mc-card-front calendar-schedule-page">
      <div class="card-body">
        <div class="calendar-schedule-header">
          <div>
            <h4 class="mb-2">{{ title }}</h4>
            <p class="text-muted mb-0">{{ description }}</p>
          </div>
          <b-button variant="outline-primary" @click="$router.push({ name: 'Planner Menu' })">
            <i class="bx bx-arrow-back"></i> {{ $t('global.back') }}
          </b-button>
        </div>

        <div class="planner-board">
          <aside class="work-order-panel">
            <div class="panel-title">
              <div>
                <h5 class="mb-1">Unscheduled Work Orders</h5>
                <small class="text-muted">Drag work order to technician row and time slot</small>
              </div>
              <b-badge variant="light" class="work-order-count">{{ unscheduledWorkOrders.length }}</b-badge>
            </div>

            <div class="technician-legend">
              <div
                v-for="technician in technicians"
                :key="technician.id"
                class="technician-legend-item"
              >
                <span
                  class="technician-dot"
                  :style="{ backgroundColor: technician.color }"
                ></span>
                <span>{{ technician.name }}</span>
              </div>
            </div>

            <div v-if="unscheduledWorkOrders.length" class="work-order-list">
              <div
                v-for="workOrder in unscheduledWorkOrders"
                :key="workOrder.id"
                class="work-order-card"
                draggable="true"
                @dragstart="onDragStart(workOrder, $event)"
                @dragend="onDragEnd"
              >
                <div class="work-order-card-top">
                  <strong>{{ workOrder.code }}</strong>
                  <div class="work-order-badges">
                    <b-badge :variant="getPriorityVariant(workOrder.priority)">
                      {{ workOrder.priority }}
                    </b-badge>
                    <b-badge :variant="getStatusVariant(workOrder.status)">
                      {{ workOrder.status }}
                    </b-badge>
                  </div>
                </div>

                <h6 class="work-order-title">{{ workOrder.title }}</h6>
                <p class="work-order-meta mb-1">{{ workOrder.customer }}</p>
                <p class="work-order-meta mb-2">
                  <i class="bx bx-map"></i> {{ workOrder.location }}
                </p>

                <div class="work-order-window">
                  <i class="bx bx-time-five"></i> {{ formatAllowedWindow(workOrder) }}
                </div>

                <div class="work-order-footer">
                  <span
                    class="technician-pill"
                    :style="{ borderColor: getTechnicianColor(workOrder.technicianId) }"
                  >
                    <span
                      class="technician-dot"
                      :style="{ backgroundColor: getTechnicianColor(workOrder.technicianId) }"
                    ></span>
                    {{ getTechnicianName(workOrder.technicianId) }}
                  </span>
                  <small class="text-muted">{{ workOrder.durationHours }}h</small>
                </div>
              </div>
            </div>

            <div v-else class="empty-work-order-list">
              <i class="bx bx-check-circle"></i>
              <p class="mb-1">All work orders scheduled</p>
              <small class="text-muted">Drag scheduled cards inside calendar to reschedule.</small>
            </div>
          </aside>

          <section class="calendar-panel">
            <div class="calendar-toolbar">
              <div>
                <h5 class="mb-1">Technician Plan</h5>
                <small class="text-muted">{{ calendarRangeLabel }} · {{ calendarView }} view · technician rows · 24-hour slots</small>
              </div>
              <div class="calendar-actions">
                <div class="view-actions">
                  <b-button
                    size="sm"
                    :variant="calendarView === 'day' ? 'primary' : 'outline-primary'"
                    @click="setCalendarView('day')"
                  >
                    Daily
                  </b-button>
                  <b-button
                    size="sm"
                    :variant="calendarView === 'week' ? 'primary' : 'outline-primary'"
                    @click="setCalendarView('week')"
                  >
                    Weekly
                  </b-button>
                </div>
                <div class="week-actions">
                  <b-button size="sm" variant="outline-secondary" @click="goToPreviousPeriod">
                    <i class="bx bx-chevron-left"></i> {{ calendarView === 'day' ? 'Prev Day' : 'Prev Week' }}
                  </b-button>
                  <b-button size="sm" variant="outline-primary" @click="goToCurrentPeriod">
                    {{ calendarView === 'day' ? 'Today' : 'This Week' }}
                  </b-button>
                  <b-button size="sm" variant="outline-secondary" @click="goToNextPeriod">
                    {{ calendarView === 'day' ? 'Next Day' : 'Next Week' }} <i class="bx bx-chevron-right"></i>
                  </b-button>
                </div>
              </div>
            </div>

            <div class="resource-calendar">
              <div class="resource-header">
                <div class="resource-corner">
                  <strong>Technician</strong>
                  <span>{{ calendarRangeLabel }}</span>
                </div>
                <div class="timeline-header">
                  <div class="day-group-row" :style="dayGroupStyle">
                    <div
                      v-for="day in visibleDays"
                      :key="day.key"
                      class="day-group"
                    >
                      <strong>{{ day.label }}</strong>
                      <span>{{ day.dateLabel }}</span>
                    </div>
                  </div>
                  <div class="hour-group-row" :style="timelineGridStyle">
                    <div
                      v-for="slot in timelineSlots"
                      :key="slot.id"
                      class="hour-header"
                    >
                      {{ slot.hour % 6 === 0 ? formatHour(slot.hour) : '' }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="resource-body">
                <div
                  v-for="technician in technicians"
                  :key="technician.id"
                  class="resource-row"
                >
                  <div class="resource-technician">
                    <div class="resource-technician-name">
                      <span
                        class="technician-dot"
                        :style="{ backgroundColor: technician.color }"
                      ></span>
                      <strong>{{ technician.name }}</strong>
                    </div>
                    <span>{{ technician.role }}</span>
                    <div class="technician-capacity">
                      <div class="capacity-row">
                        <strong>{{ getTechnicianWeekPlannedHours(technician.id) }}h</strong>
                        <span>/ {{ weeklyCapacityHours }}h</span>
                      </div>
                      <div class="capacity-bar">
                        <div
                          class="capacity-bar-fill"
                          :class="{ 'capacity-bar-fill-over': isTechnicianOverCapacity(technician.id) }"
                          :style="{ width: `${getTechnicianUtilizationPercent(technician.id)}%` }"
                        ></div>
                      </div>
                      <small>
                        {{ getTechnicianRemainingHours(technician.id) }}h remaining this week
                      </small>
                    </div>
                  </div>

                  <div class="timeline-row" :style="timelineGridStyle">
                    <div
                      v-for="slot in timelineSlots"
                      :key="`${technician.id}-${slot.id}`"
                      class="timeline-cell"
                      :class="{
                        'timeline-cell-denied': !isSlotAllowedForDraggedWorkOrder(slot.dateKey, slot.hour),
                      }"
                      @dragover.prevent
                      @drop="onDrop(technician.id, slot.dateKey, slot.hour, $event)"
                    >
                      <div
                        v-for="workOrder in getWorkOrdersBySlot(technician.id, slot.dateKey, slot.hour)"
                        :key="workOrder.id"
                        class="calendar-work-order"
                        :style="{
                          borderLeftColor: getTechnicianColor(workOrder.technicianId),
                          width: `${Math.max(workOrder.durationHours, 1) * 100}%`,
                        }"
                        draggable="true"
                        @dragstart="onDragStart(workOrder, $event)"
                        @dragend="onDragEnd"
                      >
                        <div class="calendar-work-order-code">{{ workOrder.code }}</div>
                        <div class="calendar-work-order-detail">
                          <strong>{{ workOrder.code }}</strong>
                          <span>{{ workOrder.title }}</span>
                          <small>{{ workOrder.customer }}</small>
                          <small><i class="bx bx-map"></i> {{ workOrder.location }}</small>
                          <small>{{ formatWorkOrderTime(workOrder) }}</small>
                          <small>{{ formatAllowedWindow(workOrder) }}</small>
                          <small>{{ getTechnicianName(workOrder.technicianId) }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.calendar-schedule-page {
  overflow: hidden;
}

.calendar-schedule-header {
  align-items: flex-start;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

.planner-board {
  display: grid;
  gap: 1rem;
  grid-template-columns: 300px minmax(0, 1fr);
}

.work-order-panel,
.calendar-panel {
  background: #f8f9fb;
  border: 1px solid #e8ecf2;
  border-radius: 14px;
  min-width: 0;
  padding: 1rem;
}

.panel-title,
.calendar-toolbar,
.work-order-card-top,
.work-order-footer {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
}

.calendar-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: flex-end;
}

.view-actions,
.week-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;
}

.work-order-count {
  color: #495057;
  font-size: 0.875rem;
}

.technician-legend {
  background: #ffffff;
  border: 1px solid #e8ecf2;
  border-radius: 12px;
  display: grid;
  gap: 0.5rem;
  grid-template-columns: 1fr;
  margin: 1rem 0;
  padding: 0.75rem;
}

.technician-legend-item {
  align-items: center;
  color: #495057;
  display: flex;
  font-size: 0.8125rem;
  gap: 0.5rem;
}

.technician-dot {
  border-radius: 999px;
  display: inline-block;
  flex: 0 0 8px;
  height: 8px;
  width: 8px;
}

.work-order-list {
  display: grid;
  gap: 0.85rem;
  max-height: 720px;
  overflow-y: auto;
  padding-right: 0.25rem;
}

.work-order-card {
  background: #ffffff;
  border: 1px solid #e5e9f0;
  border-radius: 12px;
  box-shadow: 0 8px 18px rgba(16, 24, 40, 0.04);
  cursor: grab;
  padding: 0.9rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.work-order-card:active {
  cursor: grabbing;
}

.work-order-card:hover {
  border-color: #b9cef8;
  box-shadow: 0 10px 22px rgba(47, 128, 237, 0.12);
  transform: translateY(-1px);
}

.work-order-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  justify-content: flex-end;
}

.work-order-title {
  color: #253047;
  font-size: 0.95rem;
  line-height: 1.35;
  margin: 0.75rem 0 0.4rem;
}

.work-order-meta {
  color: #697386;
  font-size: 0.8125rem;
}

.work-order-window {
  background: #f3f7ff;
  border: 1px solid #d8e5ff;
  border-radius: 8px;
  color: #42628f;
  font-size: 0.75rem;
  margin-bottom: 0.75rem;
  padding: 0.45rem 0.55rem;
}

.technician-pill {
  align-items: center;
  background: #ffffff;
  border: 1px solid;
  border-radius: 999px;
  color: #495057;
  display: inline-flex;
  font-size: 0.75rem;
  gap: 0.4rem;
  max-width: 220px;
  overflow: hidden;
  padding: 0.25rem 0.55rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-work-order-list {
  align-items: center;
  background: #ffffff;
  border: 1px dashed #cdd6e4;
  border-radius: 12px;
  color: #697386;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-top: 1rem;
  padding: 1.5rem;
  text-align: center;
}

.empty-work-order-list i {
  color: #27ae60;
  font-size: 2rem;
}

.calendar-toolbar {
  margin-bottom: 1rem;
}

.resource-calendar {
  --technician-width: 150px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  max-height: 780px;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}

.resource-header,
.resource-row {
  display: grid;
  grid-template-columns: var(--technician-width) minmax(0, 1fr);
  width: 100%;
}

.resource-header {
  position: sticky;
  top: 0;
  z-index: 8;
}

.resource-corner {
  background: #f1f5f9;
  border-bottom: 1px solid #dbe3ef;
  border-right: 1px solid #dbe3ef;
  color: #253047;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  left: 0;
  min-height: 76px;
  padding: 0.75rem;
  position: sticky;
  z-index: 10;
}

.resource-corner span {
  color: #697386;
  font-size: 0.75rem;
}

.timeline-header {
  background: #f1f5f9;
}

.day-group-row {
  display: grid;
}

.day-group {
  align-items: center;
  border-bottom: 1px solid #dbe3ef;
  border-left: 1px solid #dbe3ef;
  color: #253047;
  display: flex;
  gap: 0.4rem;
  justify-content: center;
  min-height: 38px;
}

.day-group span {
  color: #697386;
  font-size: 0.78rem;
}

.hour-group-row,
.timeline-row {
  display: grid;
}

.hour-header {
  align-items: center;
  border-bottom: 1px solid #dbe3ef;
  border-left: 1px solid #dbe3ef;
  color: #697386;
  display: flex;
  font-size: 0.55rem;
  font-weight: 600;
  justify-content: center;
  min-height: 24px;
  overflow: hidden;
}

.resource-body {
  position: relative;
}

.resource-row {
  min-height: 88px;
}

.resource-technician {
  background: #f8fafc;
  border-bottom: 1px solid #edf1f6;
  border-right: 1px solid #dbe3ef;
  color: #697386;
  display: flex;
  flex-direction: column;
  font-size: 0.78rem;
  gap: 0.25rem;
  justify-content: center;
  left: 0;
  padding: 0.65rem;
  position: sticky;
  z-index: 6;
}

.resource-technician-name {
  align-items: center;
  color: #253047;
  display: flex;
  gap: 0.5rem;
}

.technician-capacity {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 0.35rem;
}

.capacity-row {
  align-items: baseline;
  color: #253047;
  display: flex;
  gap: 0.25rem;
}

.capacity-row span,
.technician-capacity small {
  color: #697386;
  font-size: 0.68rem;
}

.capacity-bar {
  background: #e8eef7;
  border-radius: 999px;
  height: 5px;
  overflow: hidden;
}

.capacity-bar-fill {
  background: #27ae60;
  border-radius: inherit;
  height: 100%;
}

.capacity-bar-fill-over {
  background: #d9534f;
}

.timeline-row {
  min-height: 88px;
}

.timeline-cell {
  background: #ffffff;
  border-bottom: 1px solid #edf1f6;
  border-left: 1px solid #edf1f6;
  min-height: 88px;
  padding: 0.2rem;
  position: relative;
  transition: background-color 0.2s ease;
}

.timeline-cell:hover {
  background: #f5f9ff;
}

.timeline-cell-denied {
  background: #fff5f5;
  cursor: not-allowed;
}

.timeline-cell-denied:hover {
  background: #ffecec;
}

.timeline-cell-denied::after {
  color: #d9534f;
  content: '×';
  font-size: 0.7rem;
  left: 50%;
  opacity: 0.45;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.calendar-work-order {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dfe6f1;
  border-left: 3px solid #2f80ed;
  border-radius: 6px;
  box-shadow: 0 4px 10px rgba(16, 24, 40, 0.08);
  cursor: grab;
  display: flex;
  justify-content: center;
  left: 1px;
  min-height: 28px;
  min-width: 6px;
  overflow: visible;
  padding: 0;
  position: absolute;
  right: auto;
  top: 0.35rem;
  z-index: 3;
}

.calendar-work-order:active {
  cursor: grabbing;
}

.calendar-work-order-code {
  display: none;
}

.calendar-work-order-detail {
  background: #253047;
  border-radius: 10px;
  box-shadow: 0 14px 34px rgba(16, 24, 40, 0.22);
  color: #ffffff;
  display: none;
  flex-direction: column;
  gap: 0.25rem;
  left: 0;
  min-width: 240px;
  padding: 0.75rem;
  position: absolute;
  top: 42px;
  z-index: 30;
}

.calendar-work-order-detail small,
.calendar-work-order-detail span {
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.35;
}

.calendar-work-order:hover {
  z-index: 25;
}

.calendar-work-order:hover .calendar-work-order-detail {
  display: flex;
}

@media (max-width: 1199.98px) {
  .planner-board {
    grid-template-columns: 1fr;
  }

  .work-order-list {
    max-height: 420px;
  }
}

@media (max-width: 767.98px) {
  .calendar-schedule-header,
  .calendar-toolbar,
  .panel-title {
    align-items: stretch;
    flex-direction: column;
  }

  .calendar-actions,
  .view-actions,
  .week-actions {
    justify-content: stretch;
  }

  .view-actions .btn,
  .week-actions .btn {
    flex: 1 1 auto;
  }

  .resource-calendar {
    --technician-width: 120px;
  }
}
</style>
